(() => {
  const info = document.querySelector('product-info[id^="MainProduct-"]');
  const source = info?.querySelector('product-form .product-form__submit');
  if (!source) return;
  const bar = document.createElement('div');
  bar.className = 'ww-mobile-purchase';
  bar.hidden = true;
  const price = document.createElement('span');
  price.className = 'ww-mobile-purchase__price';
  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'ww-mobile-purchase__button';
  bar.append(price, button);
  document.body.append(bar);
  const sync = () => {
    const original = info.querySelector('product-form .product-form__submit');
    if (!original) { bar.hidden = true; return; }
    const amount = info.querySelector('.price--on-sale .price__sale .price-item--sale') || info.querySelector('.price__regular .price-item--regular');
    price.textContent = amount?.textContent.trim() || '';
    button.textContent = original.querySelector('span')?.textContent.trim() || original.textContent.trim();
    button.disabled = original.disabled || original.getAttribute('aria-disabled') === 'true';
    button.classList.toggle('is-loading', original.classList.contains('loading'));
    button.setAttribute('aria-busy', original.classList.contains('loading') ? 'true' : 'false');
  };
  button.addEventListener('click', () => {
    const original = info.querySelector('product-form .product-form__submit');
    if (!original || original.disabled || original.getAttribute('aria-disabled') === 'true') return;
    original.click();
  });
  const observer = new IntersectionObserver(([entry]) => {
    bar.hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0;
    document.body.classList.toggle('ww-purchase-visible', !bar.hidden);
  });
  observer.observe(source);
  new MutationObserver(sync).observe(info, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'] });
  sync();
})();
